import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import NationalitySelector from "./NationalitySelector";
import EthnicitySelector from "./EthnicitySelector";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "@/hooks/useTranslation";

export default function LanguagesNationalityEthnicity({
  form,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) {
  const t = useTranslation();

  return (
    <>
      <FormField
        control={form.control}
        name="languages"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel>{t.USER_FORM.LABELS.LANGUAGES}</FormLabel>
            <div>
              <FormControl>
                <LanguageSelector
                  formField={field}
                  placeholder={t.USER_FORM.PLACEHOLDERS.LANGUAGE_INPUT}
                />
              </FormControl>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="nationality"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel>{t.USER_FORM.LABELS.NATIONALITY}</FormLabel>
            <div>
              <FormControl>
                <NationalitySelector
                  formField={field}
                  placeholder={t.USER_FORM.PLACEHOLDERS.NATIONALITY_INPUT}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="ethnicity"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel>{t.USER_FORM.LABELS.ETHNICITY}</FormLabel>
            <div>
              <FormControl>
                <EthnicitySelector formField={field} />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
